import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Button, Checkbox, FormControlLabel } from "@material-ui/core";
import { withRouter, Link } from 'react-router-dom';
import { v4 as uuidv4 } from "uuid"; // Biblioteca para gerar UUIDs
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#f8f9fc", // Azul acinzentado bem claro
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    width: "60%",
    maxWidth: "800px",
    minHeight: "70vh",
    backgroundColor: "#fff",
    padding: "20px",
    boxShadow: "0px 1px 35px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoContainer: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#37474F',
    padding: '20px',
    marginBottom: '20px',
  },
  imgLogo: {
    maxWidth: '200px',
  },
  button: {
    marginTop: '30px',
    height: '100px',
    width: '250px',
  },
  termsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    alignItems: 'center',
  },
  link: {
    color: '#0073e6',
    textDecoration: 'none',
    fontWeight: 'bold',
  }
}));

const FichaCadastro = (props) => {
  const classes = useStyles();
  const { nomeEmpresa, chaveIdentificacao, nomeContato, tipoPessoa } = props.match.params;
  
  // Estado para armazenar se o termo foi aceito
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);

  const handleAcceptTerms = (event) => {
    setAcceptedTerms(event.target.checked);
  };

  return (
    <div className={classes.root}>
      <div id="div-container-main" className={classes.container}>
        <div className={classes.logoContainer}>
          <img src={nomeEmpresa.toUpperCase() == 'CENTERMAQ' ? "http://centermaq.net/img/centermaq.png" : "http://uziprint.com/img/uziprint.png"}  alt="Logo Centermaq" className={classes.imgLogo} />
        </div>
        <div style={{ padding: "10px" }}>
          <Typography variant="h4" align="center">
           Olá, <strong>{nomeContato}</strong>. Seja bem-vindo(a)  à plataforma {nomeEmpresa.toUpperCase()}.
          </Typography>
          <br />
          <Typography variant="subtitle1" align="justify" style={{ marginTop: '25px' }}>
            Ficamos felizes com seu interesse em ser nosso cliente. Para que possamos oferecer a você o melhor atendimento possível, por favor, preencha sua ficha cadastral para registro em nosso sistema.
          </Typography>
          <br />
          <br />
        </div>
        <div className={classes.termsContainer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={acceptedTerms}
                onChange={handleAcceptTerms}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                Aceito os <a href = {nomeEmpresa.toUpperCase() == 'CENTERMAQ' ?"http://centermaq.net/downloads/privacidadeCentermaq.pdf" :"http://uziprint.com/downloads/privacidadeUziprint.pdf"} target="_blank" className={classes.link}>Termo de Uso e Política de Privacidade</a>.
              </Typography>
            }
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button
            variant={!acceptedTerms ? "outlined" : "contained"}
            color={"primary"}
            size="large"
            className={classes.button}
            onClick={() => {
              if (acceptedTerms) {
                props.history.push({
                  pathname: `/fichacadastro/${nomeEmpresa}/${chaveIdentificacao}/acceptedTerms/${tipoPessoa}`,
                });
              } else {
                alert("Você precisa aceitar os Termos de Uso e Termo de Aceite.");
              }
            }}
            disabled={!acceptedTerms}
          >
            <Typography variant="h6">Começar</Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(FichaCadastro);
